export const TherapyReferralEmbedConstants = {
  panelTitle: "Therapy Screen / Referral (needs CMI Connect)",
  refreshLabel: "Refresh",
  openFullAppLabel: "Open full app",
  notConfiguredMessage: "Therapy Referrals isn't available in this environment yet.",
  timedOutMessage: "This is taking longer than expected.",
  accessNoticeMessage:
    "Requires an active CMI Connect account. Contact your administrator if you don't have access.",
};
